import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {SiteDesignService} from "../../site-design/site-design.service";
import {handleErrors} from "../../misc/handle-errors.decorator";

export interface AssociateStandaloneAccessoryModel {
  accessoryId: string;
  deploymentId: string;
}

@Component({
  templateUrl: "./associate-standalone-accessory-dialog.template.pug",
  providers: [SiteDesignService],
})
export class AssociateStandaloneAccessoryDialogComponent
  extends DialogComponent<AssociateStandaloneAccessoryModel, boolean>
  implements AssociateStandaloneAccessoryModel {
  error: Error;
  deploymentId: string;
  accessoryId: string;
  availableAssets = [];

  constructor(
    public dialogService: DialogService,
    public siteDesignService: SiteDesignService,
  ) {
    super(dialogService);
  }

  @handleErrors()
  async loadData() {
    if (!this.deploymentId) {
      throw new Error("An unexpected error occurred.");
    }

    const result = await this.siteDesignService.getAvailableAssetsToAssociateStandaloneAccessories(this.deploymentId);

    this.availableAssets = result.availableAssets;
  }

  async associate(asset) {
    await this.siteDesignService.associateStandaloneAccessoryToAsset(this.accessoryId, asset.id);
    this.result = true;
    this.close();
  }

  ready() {
    this.loadData();
  }

  cancel(): void {
    this.close();
  }
}
